import { css } from '@emotion/react'
import { IcomoonIcon } from '../../atoms/IcomoonIcon'
import { colors } from 'plume-ui'
import { useUser } from '../../../contexts/AuthContext'
import { ArticleCommon } from '../../../types'
import { lockTypeOf } from '@/lib/article'
import { desktopMinWidth } from '../../tokens/mediaquery'

type Props = {
  article: ArticleCommon
  size?: 'normal' | 'small'
}

const small = css`
  @media (min-width: ${desktopMinWidth}) {
    font-size: 24px;
  }
`

const common = css`
  margin-right: 3px;
`

export const LockIcon: React.FC<Props> = (props) => {
  const user = useUser()
  switch (lockTypeOf(user, props.article)) {
    case 'none':
      return null
    case 'locked':
      return (
        <IcomoonIcon
          name="lock-fill"
          css={css`
            ${common}
            color: ${colors.black10};
            ${props.size === 'small' && small}
          `}
        />
      )
    case 'unlocked':
      return (
        <IcomoonIcon
          name="unlock-fill"
          css={css`
            ${common}
            color: ${colors.gray60};
            ${props.size === 'small' && small}
          `}
        />
      )
  }
}
